import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    redirect: '/index',
    component: HomeView,
  },
  {
    path: "/index",
    name: "index",
    component: HomeView,
  },
  {
    path: "/about-us",
    name: "aboutUs",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutUs.vue"),
  },
  {
    path: "/business",
    name: "business",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BusinessPage.vue"),
  },
  {
    path: "/job",
    name: "job",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/JobPage.vue"),
  },
  {
    path: "/costdisclosure",
    name: "costdisclosure",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CostDisclosure.vue"),
  },
  {
    path: "/consultation",
    name: "consultation",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Consultation.vue"),
  },
  {
    path: "/info-overview",
    name: "infoOverview",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/InfoOverview.vue"),
  },
  {
    path: "/info-overview-detail",
    name: "infoOverviewDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/InfoOverviewDetail.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
